import React, { FunctionComponent } from 'react';
import ProductInstructions from '~/ProductInstructions';
import Heading from '~/UI/Heading/Heading';

import styles from './styles.less';

interface Props {
	scrollOnExport: boolean;
}

export const EnglishHelp: FunctionComponent<React.PropsWithChildren<Props>> = ({ scrollOnExport }) => {
	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<div className={styles.in}>
					<Heading>Help</Heading>
					<p className={styles.perex}>
						Cogvio Price Monitor provides you a real-time overview of medicinal product prices across Europe. Products
						can be grouped into Lists and organized into Folders. With various Folder and Lists types, your tasks such
						as maximal price or reimbursement calculation according to national rules can be easily solved. This section
						provides you a basic guidance on an effective use of Price Monitor.
					</p>
					<p className={styles.perex}>Please do not hesitate to contact us for more details on:</p>
					<ul className={styles.perexList}>
						<li>
							<a href='mailto:support@cogvio.com'>support@cogvio.com</a>
						</li>
					</ul>
				</div>
			</div>
			<div className={styles.in}>
				<ProductInstructions scrollOnExport={scrollOnExport} />
			</div>
		</section>
	);
};
EnglishHelp.displayName = 'Help.EnglishHelp';
